<template>
  <div class="activity-review-info-box bg-blue">
    <p
      class="activity-review-info-box__value"
      v-for="(item, i) in showedList"
      :key="i"
      :title="item.value"
    >
      <strong class="activity-review-info-box__title">{{item.label}}: </strong>
      {{item.value}}
    </p>
  </div>
</template>

<script>
export default {
  name: 'ReviewInfoBox',
  props: {
    company: { required: true },
    po: { required: true },
    partNumber: { required: true },
    partSN: { required: true },
    baxPO: { required: false },
    supplierCompanyName: { type: String },
    rfqType: { required: true }
  },
  computed: {
    fieldList () {
      const isBaxPO = !!this.baxPO
      const partNumberValues = [this.partNumber]
      isBaxPO && partNumberValues.push(this.partSN)
      const partNumberValue = partNumberValues.filter(Boolean).join(', ')

      return [
        {
          label: this.L10n('customer'),
          value: this.company
        },
        {
          label: this.L10n('po'),
          value: [this.po, this.rfqType].filter(Boolean).join(' | ')
        },
        {
          label: this.L10n('partNumber'),
          value: partNumberValue
        },
        ...(isBaxPO ? [
          {
            label: this.L10n('baxPO'),
            value: [this.baxPO, this.supplierCompanyName].filter(Boolean).join(', ')
          }
        ] : [
          {
            label: this.L10n('partSN'),
            value: this.partSN
          }
        ])
      ]
    },
    showedList () {
      return this.fieldList.filter(({ value }) => !!value)
    }
  }
}
</script>

<style lang="stylus">
  .activity-review-info-box {
    font-size 1.2rem
    padding .5rem
    color #65646c
    overflow hidden
    width 100%
    &__title{
      text-transform capitalize
      font-weight bold
    }
    &__value{
      white-space nowrap
      text-overflow ellipsis
      overflow hidden
      padding 0
      margin 0
    }
  }
</style>
